





























import VCard from "@/components/VCard.vue";
import VSidedPieChart from "@/components/VSidedPieChart.vue";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({ components: { VCard, VSidedPieChart } })
export default class CoverageCard extends Vue {
  @Prop({ default: 0 }) readonly regionTotal!: number;
  @Prop({ default: 0 }) readonly districtTotal!: number;
  @Prop({ default: 0 }) readonly townTotal!: number;

  @Prop({ default: 0 }) readonly regionSlice!: number;
  @Prop({ default: 0 }) readonly districtSlice!: number;
  @Prop({ default: 0 }) readonly townSlice!: number;
}
